module.exports = __webpack_public_path__ + "img/icon.3910fd4f.svg";